"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchLocationSuggestions = exports.getPlaceFromCoordinates = exports.getPlaceFromCoordinatesBase = exports.getPlaceFromGooglePlaceId = void 0;

var _lodash = require("lodash");

var _urlLib = require("url-lib");

var _transformationUtils = require("@eb/transformation-utils");

var _http = require("js-utils/http");

var _transformation = require("../../utils/transformation");

var GET_PLACE_FROM_GOOGLE_PLACE_ID_URL = '/api/v3/geo/place_from_google_place_id/';
var GET_PLACE_FROM_COORDINATES_URL = '/api/v3/geo/place_from_coordinates/';

var getPlaceFromGooglePlaceId = function getPlaceFromGooglePlaceId(googlePlaceId) {
  var queryParams = (0, _transformationUtils.deepKeysToSnake)((0, _transformation.pruneObject)({
    googlePlaceId: googlePlaceId
  }));
  return (0, _http.fetchJSON)((0, _urlLib.formatUrl)(GET_PLACE_FROM_GOOGLE_PLACE_ID_URL, queryParams));
};

exports.getPlaceFromGooglePlaceId = getPlaceFromGooglePlaceId;

var getPlaceFromCoordinatesBase = function getPlaceFromCoordinatesBase(_ref) {
  var latitude = _ref.latitude,
      longitude = _ref.longitude,
      placeType = _ref.placeType;
  var queryParams = (0, _transformationUtils.deepKeysToSnake)((0, _transformation.pruneObject)({
    latitude: latitude,
    longitude: longitude,
    placeType: placeType
  }));
  return (0, _http.fetchJSON)((0, _urlLib.formatUrl)(GET_PLACE_FROM_COORDINATES_URL, queryParams));
};

exports.getPlaceFromCoordinatesBase = getPlaceFromCoordinatesBase;

var getPlaceFromCoordinates = function getPlaceFromCoordinates(_ref2) {
  var latitude = _ref2.latitude,
      longitude = _ref2.longitude,
      placeType = _ref2.placeType;
  return new Promise(function (resolve, reject) {
    getPlaceFromCoordinatesBase({
      latitude: latitude,
      longitude: longitude,
      placeType: placeType
    }).then(function (response) {
      if ((0, _lodash.isEmpty)(response.place)) {
        reject('{latitude, longitude}');
      }

      resolve(response);
    });
  });
};

exports.getPlaceFromCoordinates = getPlaceFromCoordinates;

var searchLocationsSuggestionsUrl = function searchLocationsSuggestionsUrl(query) {
  return "/api/v3/destination/search/places/?q=".concat(query);
};

var searchLocationSuggestions = function searchLocationSuggestions(query) {
  return (0, _http.fetchJSON)(searchLocationsSuggestionsUrl(query));
};

exports.searchLocationSuggestions = searchLocationSuggestions;
//# sourceMappingURL=api.js.map